<template>
  <div id="pagetitle" class="block mr-1">
    <div class="inner">
      <h1 :class="titleClass ? titleClass : 'pt-4 pb-2'">
        <slot></slot>
      </h1>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Title',
  props: {
    titleClass: {
      type: String,
    },
  },
};
</script>
<style lang="scss" scoped>
#pagetitle {
  .inner {
    .pt-4,
    .py-4 {
      padding-top: 1.375rem !important;
      padding-bottom: 1.25rem !important;
    }
  }

  h1 {
    color: #174169;
    font-size: 22px;
    letter-spacing: 0;
    font-weight: 400;
    line-height: 30px;
    margin-bottom: 0px;
  }

  &.bg {
    .inner > .row {
      background: #fafdff;
    }
  }

  &.fixed {
    position: fixed;
  }
}
</style>
